import React from "react";

import { IgButton } from "@intelligems/ig-theme";
import { Dialog } from "@mui/material";
import { ProductPicker } from "@src/components/MainApp/SharedProductPicker/ProductPicker";
import { useDispatch, useSelector } from "@src/store";
import {
  areAnalyticsProductsLoading,
  getAnalyticsProductCount,
} from "@src/store/slices/analyticsProducts";
import {
  selectedExperience,
  setExperienceAnalyticsViewType,
} from "@src/store/slices/experiences";
import { closeProductPicker } from "@src/store/slices/productPicker";
import { isProductPickerOpen } from "@src/store/slices/productPicker/selectors/isProductPickerOpen";
import { isValidProductPickerSelection } from "@src/store/slices/productPicker/selectors/isValidProductPickerSelection";
import { saveAnalyticsProductPicker } from "@src/store/slices/productPicker/thunks/analytics/saveAnalyticsProductPicker";

export const AnalyticsProductPickerDialog = () => {
  const analyticsProductCount = useSelector(getAnalyticsProductCount);
  const analyticsProductsLoading = useSelector(areAnalyticsProductsLoading);
  const validProductPickerSelection = useSelector(
    isValidProductPickerSelection
  );
  const productPickerOpen = useSelector(isProductPickerOpen("analytics"));
  const dispatch = useDispatch();

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      open={productPickerOpen}
      sx={{ zIndex: 1401 }}
      onClose={() => {
        if (analyticsProductCount === 0) {
          dispatch(setExperienceAnalyticsViewType("sitewide_orders"));
        }
        dispatch(closeProductPicker());
      }}
      slotProps={{
        paper: {
          style: { borderRadius: 15 },
        },
      }}
    >
      <ProductPicker
        onCustomCloseFn={() => {
          if (analyticsProductCount === 0) {
            dispatch(setExperienceAnalyticsViewType("sitewide_orders"));
          }
        }}
        putExperienceStatus={
          analyticsProductsLoading
            ? {
                type: "load",
                message: "Loading products",
              }
            : undefined
        }
        dialogActions={[
          <IgButton
            key={`button-2`}
            color={"secondary"}
            onClick={() => {
              dispatch(closeProductPicker());
              if (analyticsProductCount === 0) {
                dispatch(setExperienceAnalyticsViewType("sitewide_orders"));
              }
            }}
          >
            Cancel
          </IgButton>,
          <IgButton
            key={`button-1`}
            onClick={() => void dispatch(saveAnalyticsProductPicker())}
            disabled={!validProductPickerSelection}
          >
            Add Products
          </IgButton>,
        ]}
      />
    </Dialog>
  );
};
